import { computed, inject, Service } from '@angular/core';
import { KiwidSocketService } from 'app/core/socket/kiwid-socket.service';
import { Observable } from 'rxjs';
import {
    IEmitCreateMessageClinicMessageSocket,
    IEmitGetAllMessageClinicMessageSocket,
    IEmitJoinRoomClinicMessageSocket,
    IEmitLeaveRoomClinicMessageSocket,
    IJoinRoomMessageSocket,
    IMessage,
} from 'app/core/models/message/message';
import { EEventKiwidSocket } from 'app/core/enums/socket.enum';
import { IDataPagination } from '@kiwid-app/kiwid-ui-lib-angular';

@Service()
export class ClinicMessageSocketService {
    private readonly kiwidSocketService = inject(KiwidSocketService);

    public readonly isConnected = computed(() => this.kiwidSocketService.isConnected());

    public get messages(): Observable<IMessage[]> {
        return this.kiwidSocketService.fromEvent<IMessage[]>(EEventKiwidSocket.CLINIC_MESSAGES);
    }

    public emitJoinRoom(data: IEmitJoinRoomClinicMessageSocket) {
        return this.kiwidSocketService.emitWithResponse<IJoinRoomMessageSocket>(EEventKiwidSocket.CLINIC_MESSAGE_JOIN_ROOM, data);
    }

    public emitLeaveRoom(data: IEmitLeaveRoomClinicMessageSocket) {
        return this.kiwidSocketService.emit(EEventKiwidSocket.CLINIC_MESSAGE_LEAVE_ROOM, data);
    }Ø

    public emitGetAllMessage(data: IEmitGetAllMessageClinicMessageSocket) {
        return this.kiwidSocketService.emitWithResponse<IDataPagination<IMessage[]>>(EEventKiwidSocket.CLINIC_MESSAGE_GET_ALL, data);
    }

    public emitCreateMessage(data: IEmitCreateMessageClinicMessageSocket) {
        return this.kiwidSocketService.emitWithResponse<IMessage>(EEventKiwidSocket.CLINIC_MESSAGE_CREATE, data);
    }
}
